// The "Feedback" box under a score. One component for Manual and Automatic so
// the text size cannot drift from the word cards beside it: text-sm, tight lines.
export default function FeedbackBox({ children, className = 'mb-6' }) {
    return (
        <div className={`${className} p-4 text-left bg-primary/5 rounded-xl border border-primary/10`}>
            <p className="text-sm font-medium text-primary mb-1">Phrase rhythm</p>
            <p className="text-sm leading-snug text-stone-600">{children}</p>
        </div>
    );
}
